module.exports = __webpack_public_path__ + "img/missionaries23_2019_7-7-2021.0b56038a.jpg";